import { Users, Target, Award } from 'lucide-react'
import Card from '../components/Card'

const stats = [
  { icon: Users, value: '50K+', label: 'Active Users' },
  { icon: Target, value: '100+', label: 'Tools Available' },
  { icon: Award, value: '99.9%', label: 'Uptime' },
]

export default function About() {
  return (
    <div className="space-y-12">
      <div className="text-center max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">About ToolsBucket</h1>
        <p className="text-xl text-gray-600">
          We're on a mission to make powerful tools accessible to everyone, everywhere.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {stats.map((stat, index) => {
          const Icon = stat.icon
          return (
            <Card key={index} className="text-center">
              <Card.Body>
                <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Icon className="w-6 h-6 text-primary-600" />
                </div>
                <div className="text-3xl font-bold text-gray-900 mb-2">{stat.value}</div>
                <div className="text-gray-600">{stat.label}</div>
              </Card.Body>
            </Card>
          )
        })}
      </div>

      <Card>
        <Card.Body className="prose max-w-none">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Story</h2>
          <p className="text-gray-600 mb-4">
            ToolsBucket was founded with a simple vision: to provide powerful, easy-to-use tools
            that help people work more efficiently. We believe that everyone should have access
            to professional-grade tools completely free of charge.
          </p>
          <p className="text-gray-600 mb-4">
            All our tools are 100% free to use with no registration required. We generate revenue
            through Google Ads, allowing us to keep all features accessible to everyone without
            any paywalls or subscriptions.
          </p>
          <p className="text-gray-600">
            Today, we serve thousands of users worldwide, processing millions of files every month.
            Our commitment to privacy, security, and free access drives everything we do.
          </p>
        </Card.Body>
      </Card>
    </div>
  )
}

